<template>
    <ValidationProvider
        :mode="validationMode"
        :name="label || name || 'unknown'"
        :rules="rules"
        :vid="uniqueId"
        slim
        v-slot="{ validated, valid, errors }"
    >
        <rkm-form-group
            :class="['form-group-checkbox', {'placeholder-label': label === false }]"
            :description="description"
            :invalid-feedback="errors[0]"
            :state="rules ? (validated ? valid : null) : null"
        >
            <label
                v-if="label"
                :for="id"
                :class="{ 'pb-0': buttons }"
            >
                {{ label + (rules && rules.required ? ' *' : '') }}
            </label>

            <div :class="{ inline, 'ml-2': inline }">
                <b-form-checkbox-group
                    :button-variant="buttonColor"
                    :buttons="buttons"
                    :checked="checked"
                    :class="{ 'form-group-checkbox-button-disabled': buttons && disabled }"
                    :disabled="disabled"
                    :name="name"
                    :options="options"
                    :required="required"
                    :size="size"
                    :stacked="stacked"
                    :state="rules ? (validated ? valid : null) : null"
                    :text-field="textField"
                    :value-field="valueField"
                    @change="$emit('change', $event)"
                    @input="$emit('input', $event)"
                >
                    <slot />
                </b-form-checkbox-group>
            </div>
        </rkm-form-group>
    </ValidationProvider>
</template>

<script>
// Components.
import {BFormCheckboxGroup} from 'bootstrap-vue'
import {ValidationProvider} from 'vee-validate'

// Mixins.
import {string} from './../mixins'

export default {
    components: { BFormCheckboxGroup, ValidationProvider },
    computed: {
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        },
        rules() {
            return this.disabled ? null : this.validations
        },
    },
    mixins: [string],
    model: {
        event: 'change',
        prop: 'checked',
    },
    props: {
        buttonColor: {type: String},
        buttons: {type: Boolean, default: false},
        checked: {type: [Array, Boolean, Number, String], default: null},
        description: {type: String},
        disabled: {type: Boolean},
        inline: {type: Boolean, default: false},
        label: {type: [String, Boolean], default: ''},
        large: {type: Boolean, default: false},
        name: {type: String},
        options: {type: [Array, Object], default: () => []},
        required: {type: Boolean, default: false},
        small: {type: Boolean, default: false},
        stacked: {type: Boolean},
        textField: {type: String, default: 'text'},
        validationMode: {type: String, default: 'lazy'},
        validations: {type: Object, default: null},
        valueField: {type: String, default: 'value'},
    },
}
</script>

<style scoped>
label {
    padding-bottom: 6px;
}

.inline {
    display: inline;
}
</style>